var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"fixed-tabs":"","center-active":""}},_vm._l((_vm.active),function(ref){
var route = ref.route;
var name = ref.name;
var icon = ref.icon;
return _c('v-tab',{key:route.name,attrs:{"replace":"","exact":"","to":{ name: route.name }}},[_vm._v(_vm._s(name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }